import {
  Card,
  CardHeader,
  Typography,
  Button,
  Stack,
  useMediaQuery,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { useTheme } from "@emotion/react";
import { CiUser } from "react-icons/ci";
import { GiPayMoney, GiReceiveMoney } from "react-icons/gi";
import PayCashForm from "../../payCashForm";
import {
  setPayCashSupplierDialog,
  setReceiveCashSupplierDialog,
} from "../../../../../../app/slices/walletSlice";
import ReceiveCashForm from "../../receiveCashForm";
import Permission from "../../../../../../components/userPermission/userPermission";

const SupplierTransactionsHeader = () => {
  const dispatch = useDispatch();

  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Card>
      <CardHeader
        sx={{
          flexWrap: "wrap",
          rowGap: 1.5,
          "& .MuiCardHeader-action": {
            m: 0,
            ...(smallScreen && { width: "100%" }),
          },
        }}
        title={
          <Typography variant="h4" component="div">
            كشف الحساب - الموردين
          </Typography>
        }
        avatar={<CiUser size={20} />}
        action={
          <Stack
            direction={smallScreen ? "column" : "row"}
            spacing={smallScreen ? 1 : 2}
          >
            <Permission permission="supplier_pay_cash_edit">
              <Button
                fullWidth={smallScreen}
                variant="contained"
                color="primary"
                size="medium"
                startIcon={<GiPayMoney />}
                onClick={() => dispatch(setPayCashSupplierDialog())}
              >
                تسديد مبالغ
              </Button>
            </Permission>
            <Permission permission="supplier_receive_cash_edit">
              <Button
                fullWidth={smallScreen}
                variant="contained"
                color="primary"
                size="medium"
                startIcon={<GiReceiveMoney />}
                onClick={() => dispatch(setReceiveCashSupplierDialog())}
              >
                استلام حساب الفواتير
              </Button>
            </Permission>
          </Stack>
        }
      />
      <PayCashForm />
      <ReceiveCashForm />
    </Card>
  );
};

export default SupplierTransactionsHeader;
